"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.variables = exports.fontSizeBase = exports.widths = exports.breakpointsArray = exports.breakpoints = exports.borderWidths = exports.space = void 0;

var _styledTheming = _interopRequireDefault(require("styled-theming"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/** SHARED VARIABLES */
// font base size


var fontSizeBase = 16;
exports.fontSizeBase = fontSizeBase;
var fontSizeLg = 22;
var fontSizeSm = 12.8;
var fontSizeXs = 10.24; // screen breakpoints

var breakpoints = {
  xs: '576px',
  sm: '768px',
  md: '992px',
  lg: '1280px',
  xl: '1440px'
};
exports.breakpoints = breakpoints;
var breakpointsArray = Object.values(breakpoints);
exports.breakpointsArray = breakpointsArray;
var space = [0, 4, 8, 16, 32, 64, 128, 256, 512];
exports.space = space;
var borderWidths = [0, 1, 2, 4, 8, 16];
exports.borderWidths = borderWidths;
var gutters = {
  mobile: space[3],
  desktop: space[4]
}; // add left and right outside gutter to actual container width

var widths = {
  xs: 524 + 2 * gutters['mobile'] + 'px',
  sm: 676 + 2 * gutters['desktop'] + 'px',
  md: 904 + 2 * gutters['desktop'] + 'px',
  lg: 1192 + 2 * gutters['desktop'] + 'px',
  xl: 1192 + 2 * gutters['desktop'] + 'px'
}; // shadows

exports.widths = widths;
var shadows = {
  0: 'none',
  1: '0 6px 30px rgba(0, 0, 0, 0.1)',
  2: '0 12px 50px rgba(0, 0, 0, 0.15)',
  3: '0 20px 70px rgba(0, 0, 0, 0.15)',
  4: '0 30px 90px rgba(0, 0, 0, 0.3)',
  5: '0 30px 90px rgba(0, 0, 0, 0.6)'
};
/** BRAND SPECIFIC */

var variables = (0, _styledTheming.default)('brand', {
  gentux: {
    // shared
    fontSizeBase: fontSizeBase,
    fontSizeLg: fontSizeLg,
    fontSizeSm: fontSizeSm,
    fontSizeXs: fontSizeXs,
    breakpoints: breakpoints,
    widths: widths,
    gutters: gutters,
    shadows: shadows,
    // fonts
    fontHeader: '"Roboto Condensed", sans-serif',
    fontHeadline: '"DomD Reg", serif',
    fontBody: '"Roboto", sans-serif',
    fontButton: '"Roboto Condensed", sans-serif',
    fontHeaderTextTransform: 'uppercase',
    fontHeadlineTextTransform: 'none',
    letterSpacing: {
      body: {
        1: '0',
        2: '0.2px',
        3: '0.3px'
      },
      header: {
        1: '0.03em',
        2: '0.03em',
        3: '0.03em',
        4: '0.04em',
        5: '0.06em',
        6: '0.08em'
      },
      headline: {
        1: 0,
        2: 0,
        3: 0,
        4: 0,
        5: 0,
        6: 0
      }
    },
    fontBaseLineHeight: 1.5,
    lineHeight: {
      1: '1.2',
      2: '1.2',
      3: '1.3',
      4: '1.3',
      5: '1.35',
      6: '1.45'
    },
    // font weights
    fontWeight: 600,
    fontHeadlineWeight: 400,
    // font sizes
    headerSizes: {
      xl: {
        1: 39.0625,
        2: 25,
        3: 20,
        4: 16,
        5: 12.8,
        6: 10.24
      },
      lg: {
        //1280px
        1: 39.0625,
        2: 25,
        3: 20,
        4: 16,
        5: 12.8,
        6: 10.24
      },
      md: {
        //992px
        1: 31.25,
        2: 25,
        3: 20,
        4: 16,
        5: 12.8,
        6: 10.24
      },
      sm: {
        //768px
        1: 31.25,
        2: 25,
        3: 20,
        4: 16,
        5: 12.8,
        6: 10.24
      },
      default: {
        1: 26.28851,
        2: 22.2784,
        3: 18.88,
        4: 16,
        5: 13.55932,
        6: 11.49095
      }
    },
    headlineModifier: 1.2,
    // colors
    grayLighter: '#f8f8f8',
    grayLight: '#e6e6e6',
    gray: '#cccccc',
    grayDark: '#888888',
    grayDarker: '#404042',
    primary: '#e6ce9a',
    textPrimary: '#b0893a',
    danger: '#b45250',
    white: '#ffffff',
    black: '#000000',
    transparent: 'transparent',
    muted: '#888888',
    green: '#509281',
    greenHover: '#02a87b'
  },
  menguin: {
    // shared
    fontSizeBase: fontSizeBase,
    fontSizeLg: fontSizeLg,
    fontSizeSm: fontSizeSm,
    fontSizeXs: fontSizeXs,
    breakpoints: breakpoints,
    widths: widths,
    gutters: gutters,
    shadows: shadows,
    // fonts
    fontHeader: '"Roboto", sans-serif',
    fontHeadline: '"Roboto", sans-serif',
    fontBody: '"Roboto", sans-serif',
    fontButton: '"Roboto", sans-serif',
    fontHeaderTextTransform: 'none',
    fontHeadlineTextTransform: 'none',
    letterSpacing: {
      body: {
        1: '0.65px',
        2: '0.8px',
        3: '0.8px'
      },
      header: {
        1: 0,
        2: 0,
        3: 0,
        4: '0.38px',
        5: '0.41px',
        6: '0.5px'
      },
      headline: {
        1: 0,
        2: 0,
        3: 0,
        4: '0.38px',
        5: '0.41px',
        6: '0.5px'
      }
    },
    fontBaseLineHeight: 1.625,
    lineHeight: {
      1: '1.2',
      2: '1.5',
      3: '1.5',
      4: '1.6',
      5: '1.5',
      6: '1.5'
    },
    // font weights
    fontWeight: 700,
    fontHeadlineWeight: 700,
    // font sizes
    headerSizes: {
      xl: {
        1: 50,
        2: 28,
        3: 20,
        4: 18,
        5: 13,
        6: 10
      },
      lg: {
        1: 50,
        2: 28,
        3: 20,
        4: 18,
        5: 13,
        6: 10
      },
      md: {
        1: 50,
        2: 28,
        3: 20,
        4: 18,
        5: 13,
        6: 10
      },
      sm: {
        1: 35,
        2: 28,
        3: 20,
        4: 18,
        5: 13,
        6: 10
      },
      default: {
        1: 35,
        2: 28,
        3: 20,
        4: 18,
        5: 13,
        6: 10
      }
    },
    headlineModifier: 1,
    // colors
    grayLighter: '#f8f8f8',
    grayLight: '#e6e6e6',
    gray: '#cccccc',
    grayDark: '#888888',
    grayDarker: '#404042',
    grayDefaultButton: '#e6e6e6',
    primary: '#00b9ff',
    textPrimary: '#0094cc',
    primaryHover: '#0094cc',
    danger: '#b45250',
    dangerHover: '#92403f',
    white: '#ffffff',
    black: '#000000',
    transparent: 'transparent',
    blackHover: '#4A4A4A',
    muted: '#888888',
    green: '#03DAA0',
    greenHover: '#02a87b'
  }
});
exports.variables = variables;